import React from 'react';

const PromptInput = ({
value,
onChange,
onSubmit,
onSave,
loading = false,
placeholder = "How can I help you?",
showSaveButton = true,
disabled = false,
saveButtonText = "Save & Continue",
regenerate = false,
onRegenerate = () => {},
regenerateButtonText = "Regenerate"
}) => {
const handleSubmit = (e) => {
  e.preventDefault();
  if (!loading && value.trim() && onSubmit) {
    onSubmit();
  }
};

return (
  <form onSubmit={handleSubmit} className="flex w-full   justify-end mt-8 items-center gap-4">
      {
        regenerate && (
          <button
            type="button"
            onClick={onRegenerate}
            className=" flex justify-center items-center   p-2 bg-gradient-to-r from-orange-500 to-yellow-500 rounded-lg text-white hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Regenerate
          </button>
        )
      }
      {
        !regenerate && (

    <div className="relative w-full">
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            disabled={disabled || loading}
            className="w-full px-6 py-2 pr-16 text-gray-700 bg-white border border-gray-200 rounded-full shadow-sm focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 disabled:bg-gray-50 disabled:cursor-not-allowed"
          />

      <button
        type="submit"
        disabled={loading || !value.trim() || disabled}
        className="absolute right-1 flex justify-center items-center top-1/2 -translate-y-1/2 p-2 bg-gradient-to-r from-orange-500 to-yellow-500 rounded-full text-white hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? (
          <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        ) : (
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 2L11 13" />
            <path d="M22 2L15 22L11 13L2 9L22 2Z" />
          </svg>
        )}
      </button>
    </div>
    )
      }
    {showSaveButton && (
      <button
        type="submit"
        onClick={onSave}
        disabled={disabled || loading}
        className="px-4 py-2 whitespace-nowrap bg-gradient-to-r from-orange-500 to-yellow-500 text-white rounded-lg hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {saveButtonText}
      </button>
    )}
  </form>
);
};

export default PromptInput;